<template>
    <newGsc v-if="isNewVersion"></newGsc>
    <Gsc v-else></Gsc>
</template>
<script>
import { mapGetters } from 'vuex';
import Gsc from './Gsc.vue';
import newGsc from './newHome/main.vue';

export default {
    components: {
        Gsc,
        newGsc,
    },
    computed: {
        ...mapGetters(['isNewVersion']),
    },
};
</script>
